import * as React from 'react';
import CameraLive from './CameraLive';
import {useRef, useState, useEffect} from 'react';
import styled from "styled-components";
import ShelveItem from "../field/ShelveItem";
import {colors} from "../../maps/colors";

const WrapperSvgStyled = styled.div`

`;

const SvgLayerStyled = styled.div`
  position: absolute;
  z-index: 2;
`;
export default function CameraShelfMarkerEditor(props) {

    const {
        camera,
        drawBoundingBox,
        onAddDot,
        onMoveDot,
        disableControls,
        productsDetection,
        isPreview
    } = props;

    const {profile_list, streamFullRtspUrl, pt, z, rotate} = camera;

    const [height, s_height] = useState(0);
    const [width, s_width] = useState(0);
    const [x, s_x] = useState(0);
    const [y, s_y] = useState(0);
    const [y_percent, s_y_percent] = useState(0);
    const [x_percent, s_x_percent] = useState(0);
    const [shelves, s_shelves] = useState(props.shelves || []);

    const stage = useRef(null);

    useEffect(() => {
        // shelved changed
        s_shelves(props.shelves);
    }, [props.shelves]);

    useEffect(() => {
        if (stage.current && stage.current.offsetWidth) {
            s_height(stage.current.offsetHeight);
            s_width(stage.current.offsetWidth);
        }
    }, [stage.current]);


    const mouseMove = e => {
        if (drawBoundingBox) {
            const pos = e.currentTarget.getBoundingClientRect();
            let current_x = parseInt(e.clientX - pos.left);
            let current_y = parseInt(e.clientY - pos.top);
            let current_x_percent = Number((x / width * 100).toFixed(2));
            let current_y_percent = Number((y / height * 100).toFixed(2));
            if (rotate === 90) {
                current_x_percent = Number(((y / width * 100)).toFixed(2));
                current_y_percent = Number(100 - ((x / height * 100)).toFixed(2));
            }

            if (rotate === 180) {
                current_x_percent = Number(100 - ((x / width * 100)).toFixed(2));
                current_y_percent = Number(100 - ((y / height * 100)).toFixed(2));
            }

            if (rotate === 270) {
                current_x_percent = Number(100 - ((y / width * 100)).toFixed(2));
                current_y_percent = Number(((x / height * 100)).toFixed(2));
            }

            s_x(current_x);
            s_y(current_y);
            s_x_percent(current_x_percent);
            s_y_percent(current_y_percent);

            onMoveDot({
                x: current_x,
                y: current_y,
                x_percent: current_x_percent,
                y_percent: current_y_percent
            });

        }
    };

    const mouseClick = () => {
        if (drawBoundingBox) {
            onAddDot({
                x,
                y,
                x_percent,
                y_percent
            });
        }
    };

    const calcCenterX = boundingBox => {
        let max_x = 0, min_x = 9999999;
        boundingBox?.box?.forEach(b => {
            max_x = Math.max(b?.x_percent, max_x);
            min_x = Math.min(b?.x_percent, min_x);
        });

        return (max_x - min_x) / 2 + min_x;
    };

    const calcCenterY = boundingBox => {
        let max_y = 0, min_y = 9999999;
        boundingBox?.box?.forEach(b => {
            max_y = Math.max(b?.y_percent, max_y);
            min_y = Math.min(b?.y_percent, min_y);
        });

        return (max_y - min_y) / 2 + min_y;
    };

    let cursor = 'pointer';
    if (drawBoundingBox) {
        cursor = 'crosshair';
    }

    const calcuateLayer = shelf => {
        let lowestX = 0;
        let greatestX = 0;
        let lowestY = 0;
        let greatestY = 0;

        shelf.boundingBoxes.forEach(boundingBox => {
            const box = boundingBox.box;
            box.forEach(item => {
                if (boundingBox.cameraId === camera._id) {
                    if (!lowestX || lowestX > item.x_percent) {
                        lowestX = item?.x_percent || 0 ;
                    }
                    if (!greatestX || greatestX < item.x_percent) {
                        greatestX = item?.x_percent || 0 ;
                    }
                    if (!lowestY || lowestY > item.y_percent) {
                        lowestY = item?.y_percent || 0 ;
                    }
                    if (!greatestY || greatestY < item.y_percent) {
                        greatestY = item?.y_percent || 0 ;
                    }
                }
            })
        });

        return {left: lowestX, top: lowestY, width: greatestX - lowestX, height: greatestY - lowestY};
    };

    let shelfTextRotate = 0;
    if (rotate === 90 || rotate === 270) {
        shelfTextRotate = rotate - 180;
    } else if (rotate === 180) {
        shelfTextRotate = -180;
    }

    const displayShelves = shelves.filter(shelf => shelf.boundingBoxes?.length);

    return (
        <CameraLive disableControls={disableControls} pt={pt} z={z}
                    camera={camera}
                    rotate={rotate}
                    rtspUrl={streamFullRtspUrl}
                    dynamicWidth={true}
                    resolution={`480x270`}>
            <div
                ref={stage}
                onMouseMove={mouseMove}
                onClick={mouseClick}
                style={{
                    cursor: cursor,
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    background: drawBoundingBox ? '#FFFFFF50' : 'none',
                }}>
                {
                    width && height && displayShelves.map((shelf, idx) => {
                        const layerDimensions = calcuateLayer(shelf);
                        const productsItem = productsDetection?.find(pd => {
                            return pd.sensorId === shelf.sensorId && pd.cameraId === camera.cameraId;
                        });

                        const hasProducts = !!productsItem;

                        const products = productsItem?.products;
                        return (
                            <WrapperSvgStyled
                                key={shelf._id + idx}
                            >
                                {shelf.boundingBoxes.map((boundingBox, idxx)=>{
                                    if(boundingBox.cameraId !== camera._id){
                                        return null;
                                    }

                                   return(
                                       <React.Fragment key={idxx+"box"}>
                                           <svg
                                               key={idxx+"box"}
                                               height="100%" width="100%"
                                               style={{position: 'absolute', top: 0, left: 0}}>
                                               <polygon points={
                                                   boundingBox?.box?.map(dot => {
                                                       return (
                                                           `${dot?.x_percent * width / 100},${dot?.y_percent * height / 100}`
                                                       );
                                                   }).join(',')
                                               } style={{
                                                   fill: !isPreview ? '#F8000050' : colors.LIGHT_GRAY_HALF_TRANS,
                                                   stroke: 'white',
                                                   strokeWidth: 2
                                               }}/>
                                               <text
                                                   x={calcCenterX(boundingBox) * width / 100}
                                                   y={calcCenterY(boundingBox) * height / 100}
                                                   transform={`rotate(${shelfTextRotate} ${calcCenterX(boundingBox) * width / 100} ${calcCenterY(boundingBox) * height / 100})`}
                                                   textAnchor="middle"
                                                   fill="white"
                                                   fontSize="20"
                                                   fontWeight="bold">
                                                   {shelf?.sensor?.boardId}
                                               </text>
                                           </svg>
                                           {hasProducts && (
                                               <SvgLayerStyled
                                                   style={{
                                                       top: `${layerDimensions.top}%`,
                                                       left: `${layerDimensions.left}%`,
                                                       width: `${layerDimensions.width}%`,
                                                       height: `${layerDimensions.height}%`
                                                   }}
                                               >
                                                   <ShelveItem
                                                       style={{height: "100%"}}
                                                       shelf={shelf}
                                                       products={products}
                                                       isPreviewForCamera={true}
                                                   />
                                               </SvgLayerStyled>
                                           )}
                                       </React.Fragment>
                                   )
                                })}
                            </WrapperSvgStyled>
                        );
                    })
                }
            </div>
        </CameraLive>);
}